var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6312 2.46134C12.8124 4.50509 10.9437 7.17384 9.1624 8.91759C8.90615 7.30509 7.61865 6.04259 5.99365 5.81759C7.74365 4.03009 10.4312 2.13634 12.4812 1.31134C12.8437 1.17384 13.2062 1.28009 13.4312 1.50509C13.6687 1.74259 13.7812 2.09884 13.6312 2.46134Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61245 9.43281C8.48745 9.53906 8.36245 9.64531 8.23745 9.74531L7.1187 10.6391C7.1187 10.6203 7.11245 10.5953 7.11245 10.5703C7.02495 9.90156 6.71245 9.28281 6.2062 8.77656C5.6937 8.26406 5.0562 7.95156 4.3562 7.86406C4.33745 7.86406 4.31245 7.85781 4.2937 7.85781L5.19995 6.71406C5.28745 6.60156 5.3812 6.49531 5.4812 6.38281L5.9062 6.43906C7.24995 6.62656 8.3312 7.68281 8.5437 9.02031L8.61245 9.43281Z",
    fill: "#FB4764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51885 11.015C6.51885 11.7025 6.25635 12.3587 5.75635 12.8525C5.3751 13.24 4.8626 13.5025 4.2376 13.5775L2.70635 13.7462C1.86885 13.84 1.1501 13.1212 1.24385 12.2775L1.4126 10.74C1.5626 9.3712 2.70635 8.4962 3.91885 8.4712C4.0376 8.46495 4.16885 8.4712 4.29385 8.4837C4.8251 8.55245 5.3376 8.7962 5.76885 9.2212C6.1876 9.63995 6.4251 10.1337 6.49385 10.6525C6.50635 10.7775 6.51885 10.8962 6.51885 11.015Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.eb791add00f5edc0af7140eda03aea97.svg";
export { ForwardRef as ReactComponent };